import { type IpFilterFilteredEntities, PLAN_TYPE } from '@nx/state';

export enum IP_FILTERING_SCOPE {
  PROJECT = 'PROJECT',
  ORGANIZATION = 'ORGANIZATION',
}

export enum IP_FILTERING_ACTION {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export const MAX_ALLOW_LIST_SIZE = { [PLAN_TYPE.SELF_SERVE]: 20, [PLAN_TYPE.ENTERPRISE]: 100 };

export type AllowListEntry = {
  IpRange: string;
  Description?: string;
};

// Create with required fields
export type IpFilterData = {
  name?: string;
  allowList?: AllowListEntry[];
  description?: string;
  filteredEntities?: IpFilterFilteredEntities;
};
